import { loadPageIsomorphicFiles } from '../shared/loadPageIsomorphicFiles';
import { objectAssign } from './utils';
import { getAllPageFiles } from '../shared/getPageFiles';
export { loadPageFiles };
async function loadPageFiles(pageContext) {
    const pageFiles = {};
    const allPageFiles = await getAllPageFiles();
    objectAssign(pageFiles, { _allPageFiles: allPageFiles });
    const { Page, pageExports, pageIsomorphicFile, pageIsomorphicFileDefault } = await loadPageIsomorphicFiles({
        ...pageContext,
        ...pageFiles,
    });
    objectAssign(pageFiles, {
        Page,
        pageExports,
        _pageIsomorphicFile: pageIsomorphicFile,
        _pageIsomorphicFileDefault: pageIsomorphicFileDefault,
    });
    return pageFiles;
}
